// extracted by mini-css-extract-plugin
export default {"favicon":"OrganizationFavicon_favicon__738hf"};